import React, { CSSProperties, ReactElement } from 'react';

import styles from './devicePng.module.css';
import { Machine } from '../../../gql/graphql';

let GM8 = require('../../../resources/icon/devices/devicePng/GM8.png');
let GM50 = require('../../../resources/icon/devices/devicePng/GM50.png');
let GM75 = require('../../../resources/icon/devices/devicePng/GM75.png');
let GM85 = require('../../../resources/icon/devices/devicePng/GM85.png');
let GM100 = require('../../../resources/icon/devices/devicePng/GM100.png');
let GM2000 = require('../../../resources/icon/devices/devicePng/GM2000.png');
let COMPRESSOR = require('../../../resources/icon/equipments/equipmentsPng/kompura.png');
let MachineDefault = require('../../../resources/icon/devices/devicePng/machine.png');
let MachineDefaultLarge = require('../../../resources/icon/devices/devicePng/icon-machineLarge.png');

export const getDeviceImagePng = (
    device: Machine | undefined,
    style?: CSSProperties,
    typeName?: string
): React.FunctionComponent => {
    const useName = typeName
        ? typeName
        : device
        ? device.MachineType && device.MachineType.Name
            ? device.MachineType.Name
            : device
        : '';

    let maskRules = 'center center / contain no-repeat';

    switch (useName) {
        case 'GMair35':
        case 'GMair80':
            return () => (
                <div
                    style={{
                        mask: `  url(${COMPRESSOR})  ${maskRules}`,
                        WebkitMask: `  url(${COMPRESSOR})  ${maskRules}`,
                        maskMode: 'alpha',
                        maskSize: 'contain',
                        WebkitMaskSize: 'contain',
                        ...style
                    }}
                    className={style ? '' : styles.masking}
                ></div>
            );
        case 'GM8':
            return () => (
                <div
                    style={{
                        mask: `  url(${GM8})  ${maskRules}`,
                        WebkitMask: `  url(${GM8})  ${maskRules}`,
                        ...style
                    }}
                    className={style ? '' : styles.masking}
                ></div>
            );
        case 'GM50':
        case 'GM65':
            return () => (
                <div
                    style={{
                        mask: `  url(${GM50})  ${maskRules}`,
                        WebkitMask: `  url(${GM50})  ${maskRules}`,
                        ...style
                    }}
                    className={style ? '' : styles.masking}
                ></div>
            );
        case 'GM75':
            return () => (
                <div
                    style={{
                        mask: `  url(${GM75})  ${maskRules}`,
                        WebkitMask: `  url(${GM75})  ${maskRules}`,
                        ...style
                    }}
                    className={style ? '' : styles.masking}
                ></div>
            );
        case 'GM85':
            return () => (
                <div
                    style={{
                        mask: `  url(${GM85})  ${maskRules}`,
                        WebkitMask: `  url(${GM85})  ${maskRules}`,
                        ...style
                    }}
                    className={style ? '' : styles.masking}
                ></div>
            );
        case 'GM100':
        case 'GM200':
        case 'GMe100':
            return () => (
                <div
                    style={{
                        mask: `  url(${GM100})  ${maskRules}`,
                        WebkitMask: `  url(${GM100})  ${maskRules}`,
                        ...style
                    }}
                    className={style ? '' : styles.masking}
                ></div>
            );
        case 'GM2000':
            return () => (
                <div
                    style={{
                        mask: `  url(${GM2000})  ${maskRules}`,
                        WebkitMask: `  url(${GM2000})  ${maskRules}`,
                        ...style
                    }}
                    className={style ? '' : styles.masking}
                ></div>
            );
        default:
            return () => (
                <div
                    style={{
                        mask: `  url(${MachineDefaultLarge})  ${maskRules}`,
                        WebkitMask: `url(${MachineDefaultLarge})  ${maskRules}`,
                        ...style
                    }}
                    className={style ? '' : styles.masking}
                ></div>
            );
    }
};
